<template>
  <HeaderContainer
    :type="$isSupport ? 'supportHeader' : undefined"
    class="common-header"
    :class="[isPassport ? 'passport' : false, $platformClass]"
  >
    <p class="common-header-title text-l" :class="$platformClass">
      {{ title || letters._headerTitle }}
    </p>
    <!-- <a v-if="showBack" class="common-header-back" href="javascript:;" @click="goBack"></a> -->
    <Icon
      v-if="showBack && isShowInWebviewBack"
      class="common-header-back"
      :class="$platformClass"
      @click="goBack"
      type="commonHeaderBack"
    ></Icon>
    <keep-alive v-if="showLang && !this.uidGame">
      <select-lang
        v-if="showLang && !this.uidGame"
        :is-passport="isPassport"
        class="common-header-lang"
        :class="$platformClass"
      ></select-lang>
    </keep-alive>
  </HeaderContainer>
</template>
<script>
import SelectLang from './selectLang.vue';
import getLetters from '../../mixins/getLetters.js';
import globalConfig from '../../utiles/globalConfig.js';
import { mapGetters } from 'vuex';
import bridge from '@utiles/bridge';
const isInSdk = bridge.runInsdk();

export default {
  name: 'common-header',
  mixins: [getLetters],
  props: {
    title: {
      type: String,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showLang: {
      type: Boolean,
      default: true
    },
    isPassport: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      routeNow: '',
      deepLink: '',
      uidGame: globalConfig.isUidGame()
    };
  },
  computed: {
    ...mapGetters({
      pageComponent: 'getPageComponent'
    }),
    isShowInWebviewBack() {
      // 如果是在dana小程序里面就不展示返回按钮
      if(globalConfig.isDanaMiniProgram()) {
        return false;
      }
      // 如果是密码找回页面并且在webview里面。就不显示返回按钮
      if (['findPwd'].includes(this.$route.name) && isInSdk) {
        return false;
      }
      // 如果是工单的这个几个页面'creatework', 'mylist', 'mywork'。并且返回按钮是游戏返回。并且在webview里面。就不显示返回按钮
      return !(
        ['creatework', 'mylist', 'mywork'].includes(this.$route.name) &&
        this.$route.name === this.pageComponent &&
        this.deepLink &&
        isInSdk
      );
    }
  },
  created: function () {
    let vm = this;
    this.routeNow = vm.$route.name;
    let sdkToken = globalConfig.getHrefParam('sdkToken');
    this.deepLink = sdkToken ? `javascript:window.open('${sdkToken}://')` : '';
  },
  methods: {
    goBack: function () {
      if (this.$route.name === this.pageComponent && this.deepLink) {
        this.deepLink && this.backToGame();
      } else {
        this.$router.go(-1);
      }
    },
    backToGame() {
      let aLink = document.createElement('a');
      aLink.href = this.deepLink;
      document.body.append(aLink);
      aLink.click();
    }
  },
  components: {
    SelectLang
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';

.common-header {
  width: 100%;
  height: 99px;
  line-height: 99px;
  padding: 0 30px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  @include bgC(#f3f3f3);
  &.passport {
    height: 60px;
    position: static;
    margin-bottom: 15px;
    .common-header-title {
      font-size: 22px;
      line-height: 60px;
      height: 60px;
      position: static;
    }
    .common-header-back {
      top: 20px;
    }
    .common-header-lang {
      right: 15px;
      top: 11px;
    }
  }
  &-back {
    @include size(11, 19);
    @include bgPng('arrow-left');
    @include abs-l-t(30, 40);
    text-align: left;
    /*!rtl:raw:
      transform: scaleX(-1);
    */
  }
  &-title {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 100px;
  }
  &-lang {
    @include abs-r-t(30, 30);
  }
}
</style>
